import { getAuctionVendors } from "@/repositories/kintoneConvertor";

export default {
  async fetchAuctionVendorFromJC() {
    return await getAuctionVendors();
  },
};
